module.exports = __webpack_public_path__ + "img/web_anzxz_btn.6281da9a.png";